import { action, makeObservable, observable } from 'mobx';

export type PluginsTab = 'integrations' | 'skills' | 'coding-agents';

export const PLUGINS_TAB_LABELS: Record<PluginsTab, string> = {
  integrations: 'Connectors',
  skills: 'Skills',
  'coding-agents': 'Coding agents',
};

class PluginsStore {
  activeTab: PluginsTab = 'integrations';

  constructor() {
    makeObservable(this, {
      activeTab: observable,
      setActiveTab: action,
    });
  }

  setActiveTab(tab: PluginsTab) {
    this.activeTab = tab;
  }
}

export const pluginsStore = new PluginsStore();
